import React, { useState } from "react";
import { truncate } from "lodash";

import VenueTabSearchModal from "./VenueTabSearchModal"

import Button from "Button";

const OrderListView = ({
  orders,
  orderId,
  selectTab,
  isModifyingOrder,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false)

  const filteredOrders = orders.filter((order) =>
    (order.customer.name || "Unknown Customer")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="StoreMenu">
      <div className="mb-4 mt-4">
        <input
          type="text"
          className="input"
          placeholder="Search My Tabs by Customer Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

      </div>
      <div className="is-flex is-align-items-center mb-4">
        <h3 className="title is-size-4 mb-2 is-flex-grow-1">Orders on Tab</h3>
        <Button
          className="ml-6"
          color="primary"
          onClick={() => setIsSearchModalOpen(true)}
          text="Search Venue Tabs"
        />
      </div>
      {filteredOrders.length === 0 ? (
        <p className="has-text-centered">No orders found.</p>
      ) : (
        <div className="py-2">

          <div className="flex-table">
            {filteredOrders.map((order, i) => (
              <div key={"order" + i} className="flex-table-item">
                <span className="is-absolute p-2 has-background-success" />
                <h5 className="flex-table-cell is-size-5 is-flex-grow-4" >
                  {truncate(order.formattedCustomer || "Unknown Customer", 50)}
                </h5>
                <div className="flex-table-cell">
                  Total: ${order.total}
                </div>
                <div className="flex-table-cell cell-end">
                  { orderId == order.id ? (
                  <Button
                    text="Selected"
                    disabled={true}
                    color="green"
                    loading={isModifyingOrder}
                    className="ml-auto"
                    />
                  ) : (
                  <Button
                    text="Select"
                    disabled={isModifyingOrder}
                    loading={isModifyingOrder}
                    className="ml-auto"
                    onClick={() => selectTab(order)}
                  />)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <VenueTabSearchModal
        selectTab={selectTab}
        isOpen={isSearchModalOpen}
        setIsOpen={setIsSearchModalOpen}
      />
    </div>
  );
};

export default OrderListView;
